module.exports = __webpack_public_path__ + "static/img/充值规则.210bde6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/recharge/充值规则.png
// module id = 8qya
// module chunks = 1